import { createRoot } from 'react-dom/client'
import { HelmetProvider } from 'react-helmet-async'
import { useEffect } from 'react'
import App from './App.tsx'
import './index.css'
import './sentry.client'
import './vitals'
import { ErrorBoundary } from './components/ErrorBoundary'
import { ensureGA } from './lib/analytics-lazy'
import { ensureFonts } from './lib/fonts-lazy'

// Deferir Service Worker para no tocar el LCP
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    import('./sw/registerServiceWorker')
      .then(m => m.setupServiceWorker())
      .catch(() => {});
  });
}

// Global Calendly event tracking - MOVED TO GTM (index.html)
// Replaced by GTM dataLayer push in index.html to avoid duplicates

function AppRoot() {
  useEffect(() => { 
    ensureFonts();   // fuentes en idle → no bloquea
    // Defer analytics loading to improve LCP
    setTimeout(() => ensureGA(), 100);
  }, []);
  return (
    <HelmetProvider>
      <ErrorBoundary>
        <App />
      </ErrorBoundary>
    </HelmetProvider>
  );
}

createRoot(document.getElementById("root")!).render(<AppRoot />);
